import { render, staticRenderFns } from "./Evalution-summary-note.vue?vue&type=template&id=9ccfdcc4&scoped=true"
import script from "./Evalution-summary-note.vue?vue&type=script&lang=js"
export * from "./Evalution-summary-note.vue?vue&type=script&lang=js"
import style0 from "./Evalution-summary-note.vue?vue&type=style&index=0&id=9ccfdcc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccfdcc4",
  null
  
)

export default component.exports